import { type CurrencyFormat } from "./depict-transforms"

const formatPrice = (
    price: string,
    currentPricelist: CurrencyFormat | undefined,
    fallbackCurrencySuffix: string
): string => {
    const pre = currentPricelist?.prefix || ""
    const currencySuffix =
        currentPricelist?.suffix || ` ${fallbackCurrencySuffix || currentPricelist?.name}` // fallback on currency in the middleware
    const decimalPoint = currentPricelist?.decimalPoint || ","
    const decimalDigits = Number(currentPricelist?.decimalDigits || "2") // Ensure decimalDigits is a number with default of 2
    const thousandsSeparator = currentPricelist?.thousandsSeparator || " "
    // Format the price with the specified number of decimal digits
    const formattedPrice = parseInt(price).toFixed(decimalDigits)

    // Split the formatted price into integer and decimal parts
    const [integerPart, decimalPart] = formattedPrice.split(".")

    // Apply thousands separator to the integer part
    const integerWithSeparator = integerPart.replace(
        /\B(?=(\d{3})+(?!\d))/g,
        thousandsSeparator
    )

    // Combine integer part, decimal point, and decimal part with custom formatting
    const customFormattedPrice = decimalPart
        ? `${integerWithSeparator}${decimalPoint}${decimalPart}`
        : integerWithSeparator

    // Combine currency prefix, formatted price, and suffix
    return `${pre}${customFormattedPrice}${currencySuffix}`
}

export default formatPrice
